import React from "react";
import { SectionContainer, MainTitle } from "./styles";
import Expandable from "./components/Expandable";

const GeneralDoubts = () => {
  return (
    <SectionContainer>
      <MainTitle>
        Dúvidas Gerais sobre o Portal de desenvolvedores do Sebrae
      </MainTitle>
      <Expandable
        title="O que é o Portal Desenvolvedores do Sebrae?"
        description="É uma plataforma voltada para os desenvolvedores conhecerem, testarem e consumirem as APIs do Sebrae"
      />
      <Expandable
        title="O que vou encontrar no Portal Desenvolvedores do Sebrae?"
        description="Estamos constantemente aprimorando a jornada do Portal  Developers do Sebrae, desde o lançamento da primeira versão do Portal. Na versão atual, os usuários do Banco do Sebrae poderão efetuar cadastro no Portal e obter de forma automatizada chaves de teste para a APIs, discutir com nossa equipe e outros desenvolvedores através do Fórum e conhecer a documentação das demais APIs que estão em desenvolvimento no Sebrae."
      />
      <Expandable
        title="O que posso fazer no Portal?"
        description="No Portal Developers do Sebrae  você terá acesso a documentação das APIs, Fórum para esclarecer dúvidas, além de ferramentas de cadastramento e gerenciamento das aplicações em ambiente de Teste."
      />
      <Expandable
        title="Quanto tenho que pagar para usar o Portal Desenvolvedores do Sebrae?"
        description="Cada API possui recursos e funcionalidades específicas, que serão comercializadas oportunamente de acordo com seu modelo de negócio. Nesse momento, queremos testar junto com os desenvolvedores as API de Cobrança e de Pix. Por isso, nesse primeiro momento, não há cobrança pelo uso da API em ambiente de Teste."
      />
      <Expandable
        title="Como criar uma aplicação?"
        description="Para criar uma aplicação, você deve acessar o menu lateral “Aplicações” e no canto superior direito o botão “Criar Aplicação”. Basta preencher os campos obrigatórios (nome da aplicação, descrição e URI de callback)"
      />
    </SectionContainer>
  );
};

export default GeneralDoubts;
